import { render, staticRenderFns } from "./FormRender1.vue?vue&type=template&id=82afd60c&scoped=true&"
import script from "./FormRender1.vue?vue&type=script&lang=js&"
export * from "./FormRender1.vue?vue&type=script&lang=js&"
import style0 from "./FormRender1.vue?vue&type=style&index=0&id=82afd60c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82afd60c",
  null
  
)

export default component.exports